(function (window) {
  if (window.CouponCodeManager) return;

  var root =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
    '/';

  async function getFreshCart() {
    return fetch(root + 'cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (res) {
      return res.json();
    });
  }

  var CouponCodeManager = {
    getAppliedCoupons: function (cart) {
      if (!cart) return [];

      if (Array.isArray(cart.discount_codes) && cart.discount_codes.length > 0) {
        return cart.discount_codes
          .filter(function (d) {
            return d && d.applicable !== false;
          })
          .map(function (d) {
            return (d.code || '').toString().trim();
          })
          .filter(Boolean);
      }

      if (
        Array.isArray(cart.cart_level_discount_applications) &&
        cart.cart_level_discount_applications.length > 0
      ) {
        return cart.cart_level_discount_applications
          .map(function (d) {
            return (d.title || d.code || '').toString().trim();
          })
          .filter(Boolean);
      }

      return [];
    },

    isCouponApplicable: function (cart, code) {
      if (!cart || !code) return false;

      var codeNorm = code.toLowerCase().trim();

      if (Array.isArray(cart.discount_codes) && cart.discount_codes.length > 0) {
        return cart.discount_codes.some(function (d) {
          if (!d || !d.code) return false;
          return d.applicable === true && d.code.toLowerCase().trim() === codeNorm;
        });
      }

      return false;
    },

    applyDiscount: async function (code) {
      if (!code || !code.toString().trim()) {
        return Promise.reject(new Error('Coupon code is empty.'));
      }

      var normalized = code.toString().trim();

      return fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          discount: normalized,
        }),
      })
        .then(function (res) {
          return res.json().catch(function () {
            return {};
          });
        })
        .then(function () {
          return getFreshCart();
        });
    },

    removeDiscount: async function () {
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          discount: '',
        }),
      })
        .then(function (res) {
          return res.json().catch(function () {
            return {};
          });
        })
        .then(function () {
          return getFreshCart();
        });
    },
  };

  window.CouponCodeManager = CouponCodeManager;
})(window);